import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import NewLoginPage from './pages/NewLoginPage';
import NewHomePage from './pages/NewHomePage';
import SettingsNewPage from './pages/SettingsNewPage';
import RewardsPage from './pages/RewardsPage';
import ExternalDiscountsPage from './pages/ExternalDiscountsPage';
import QuestionsPage from './pages/QuestionsPage';
import ConnectionsPage from './pages/ConnectionsPage';
import PassengersPage from './pages/PassengersPage';
import PromotionsPage from './pages/PromotionsPage';
import RedemptionValidationPage from './pages/RedemptionValidationPage';
import RedemptionsManagementPage from './pages/RedemptionsManagementPage';
import RegisterStayPage from './pages/RegisterStayPage';
import NotificationsPage from './pages/NotificationsPage';
import ContactInquiriesPage from './pages/ContactInquiriesPage';
import MainLayout from './components/Layout/MainLayout';
import { useAuth } from './context/AuthContext';

const App = () => {
  const { authToken } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Navigate to={authToken ? "/home" : "/login"} />} />
      <Route path="/login" element={!authToken ? <NewLoginPage /> : <Navigate to="/home" />} />
      <Route path="*" element={
        authToken ? (
          <MainLayout>
            <Routes>
              <Route path="/home" element={<NewHomePage />} />
              <Route path="/settings" element={<SettingsNewPage />} />
              <Route path="/passengers" element={<PassengersPage />} />
              <Route path="/stays/register" element={<RegisterStayPage />} />
              <Route path="/promotions" element={<PromotionsPage />} />
              <Route path="/redemptions/validate" element={<RedemptionValidationPage />} />
              <Route path="/redemptions/manage" element={<RedemptionsManagementPage />} />
              <Route path="/rewards" element={<RewardsPage />} />
              <Route path="/discounts" element={<ExternalDiscountsPage />} />
              <Route path="/products" element={<div>Products Page - En construcción</div>} />
              <Route path="/connections" element={<ConnectionsPage />} />
              <Route path="/questions" element={<QuestionsPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/contact-inquiries" element={<ContactInquiriesPage />} />
            </Routes>
          </MainLayout>
        ) : (
          <Navigate to="/login" />
        )
      } />
    </Routes>
  );
};

export default App;
